import { RouteComponentProps, LocationProps, WindowLocation } from '@reach/router';
import React, { useContext, useState, useEffect } from 'react';
import { Query } from 'react-apollo';
import { DetailHeader } from '../../../../components/pageElements';
import { ErrorScreen } from '../../../../components/utils';
import { NotebookContext } from '../../../../context/NotebookContext';
import NotebookLayout from '../../../../layouts/NotebookLayout';
import {
  GroupBySlugQuery,
  GroupBySlugQueryVariables
} from '../../../../queries/__generated__/GroupBySlugQuery';
import { groupBySlugQuery } from '../../../../queries/groups';
import GroupData from './data';
import GroupFeed from './feed';
import GroupSettings from './settings';

interface GroupProps extends RouteComponentProps {
  location: WindowLocation;
  initialActiveTab: 'DATA' | 'FEED' | 'SETTINGS';
  groupSlug: string;
}

const Group: React.FC<GroupProps> = ({ location, groupSlug, initialActiveTab = 'DATA' }) => {
  const { notebook } = useContext(NotebookContext);
  const [activeTab, setActiveTab] = useState(initialActiveTab);

  useEffect(() => {
    if (location.state && location.state.isEmpty) {
      setActiveTab('SETTINGS');
    }
  }, []);

  return (
    <div
      className="w-100 center pb5 pt5"
      style={{
        maxWidth: 695
      }}
    >
      <Query<GroupBySlugQuery, GroupBySlugQueryVariables>
        query={groupBySlugQuery}
        variables={{ slug: groupSlug, notebookId: notebook.id }}
      >
        {({ data, loading, error }) => {
          if (loading) {
            return <div />;
          }
          if (error) {
            return <ErrorScreen error={error.message} />;
          }

          const group = data!.groupBySlug!;

          return (
            <>
              <DetailHeader detail={group} activeTab={activeTab} setActiveTab={setActiveTab} />

              {activeTab === 'DATA' && <GroupData group={group} setActiveTab={setActiveTab} />}
              {activeTab === 'FEED' && (
                <GroupFeed group={group} notebookId={notebook.id} setActiveTab={setActiveTab} />
              )}
              {activeTab === 'SETTINGS' && <GroupSettings group={group} />}
            </>
          );
        }}
      </Query>
    </div>
  );
};

export default Group;
